<section class="cron-editor-main form-field-density-4">
    <mat-tab-group class="cron-editor-container" mat-stretch-tabs="false" mat-align-tabs="start" (selectedIndexChange)="onTabFocus($event)" [backgroundColor]="backgroundColor" [color]="color">

      <!-- Minute -->
      <mat-tab class="cron-editor-tab" label="Minutos" *ngIf="!options.hideMinutesTab">
        <div class="cron-editor-tab-content">

          <span class="cron-form-label">Todos </span>

            <cron-time-picker
              [formGroup]="minutesForm"
              [use24HourTime]="options.use24HourTime"
              [hideHours]="true"
              [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz">
            </cron-time-picker>
        </div>
      </mat-tab>

      <!-- Hourly -->
      <mat-tab class="cron-editor-tab" label="Hora" *ngIf="!options.hideHourlyTab">
        <div class="cron-editor-tab-content">
          <span class="cron-form-label">Todos </span>

          <cron-time-picker [formGroup]="hourlyForm"
                              [use24HourTime]="options.use24HourTime"
                              [hideSeconds]="options.hideSeconds ||  !isCronFlavorQuartz">
          </cron-time-picker>
        </div>
      </mat-tab>


      <!-- Daily-->
      <mat-tab class="cron-editor-tab" label="Diário" *ngIf="!options.hideDailyTab">
        <div class="cron-editor-tab-content" [formGroup]="dailyForm">

          <mat-radio-group class="cron-editor-radio-group" formControlName="subTab">
            <mat-radio-button name="subTab" class="cron-editor-radio-button" value="everyDays" checked="checked">

              <span class="cron-form-label">Todos </span>

              <mat-form-field formGroupName="everyDays">
                <mat-label>Dia(s)</mat-label>
                <mat-select formControlName="days">
                  <mat-option *ngFor="let monthDay of selectOptions.monthDays" [value]="monthDay">
                    {{monthDay}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

               no

              <cron-time-picker
                formGroupName="everyDays"
                [use24HourTime]="options.use24HourTime"
                [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz">
              </cron-time-picker>

            </mat-radio-button>

            <mat-radio-button name="subTab" class="cron-editor-radio-button" value="everyWeekDay">

              <span>Semana (SEG-SEX) na </span>

              <cron-time-picker
                formGroupName="everyWeekDay"
                [use24HourTime]="options.use24HourTime"
                [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz">
              </cron-time-picker>

            </mat-radio-button>
          </mat-radio-group>
          </div>
      </mat-tab>

      <!-- Weekly-->
      <mat-tab  class="cron-editor-tab" label="Semanal" *ngIf="!options.hideWeeklyTab">
        <div class="cron-editor-tab-content">

          <span class="cron-form-label">Todos </span>

          <div [formGroup]="weeklyForm">
            <mat-checkbox class="checkbox-margin" formControlName="MON">Segunda-Feira</mat-checkbox>
            <mat-checkbox class="checkbox-margin" formControlName="TUE">Terça-Feira</mat-checkbox>
            <mat-checkbox class="checkbox-margin" formControlName="WED">Quarta-Feira</mat-checkbox>
            <mat-checkbox class="checkbox-margin" formControlName="THU">Quinta-Feira</mat-checkbox>
            <mat-checkbox class="checkbox-margin" formControlName="FRI">Sexta-Feira</mat-checkbox>
            <mat-checkbox class="checkbox-margin" formControlName="SAT">Sábado</mat-checkbox>
            <mat-checkbox class="checkbox-margin" formControlName="SUN">Domingo</mat-checkbox>
          </div>


          <span class="cron-form-label">no horário </span>

          <cron-time-picker [formGroup]="weeklyForm"
                            [use24HourTime]="options.use24HourTime"
                            [hideSeconds]="options.hideSeconds|| !isCronFlavorQuartz">
          </cron-time-picker>
        </div>

    </mat-tab>

      <!-- Monthly-->
      <mat-tab class="cron-editor-tab" label="Mensal" *ngIf="!options.hideMonthlyTab">

        <div class="cron-editor-tab-content" [formGroup]="monthlyForm">


          <mat-radio-group formControlName="subTab">

            <mat-radio-button  name="monthly-radio" value="specificDay" >

              <!-- Spesific day -->
              <span formGroupName="specificDay">

                No

                <ng-container *ngIf="options.cronFlavor === 'quartz'">
                  <mat-form-field>
                    <mat-label>Dia</mat-label>
                    <mat-select class="month-days" formControlName="day">
                      <option *ngFor="let monthDaysWithLast of selectOptions.monthDaysWithLasts" [value]="monthDaysWithLast">
                        {{monthDayDisplay(monthDaysWithLast)}}
                      </option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngIf="options.cronFlavor === 'standard'">
                  <mat-form-field>
                    <mat-label>Dia</mat-label>
                    <mat-select class="month-days"  formControlName="day">
                      <mat-option *ngFor="let monthDaysWithOutLast of selectOptions.monthDaysWithOutLasts" [value]="monthDaysWithOutLast">
                        {{monthDayDisplay(monthDaysWithOutLast)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

                de sempre

                <ng-container>
                  <mat-form-field>
                    <mat-label>Mes</mat-label>
                    <mat-select class="months-small" formControlName="months" [ngClass]="options.formSelectClass">
                      <mat-option *ngFor="let month of selectOptions.months" [value]="month">
                        {{month}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

                no horário

                <cron-time-picker [disabled]="disabled" [formGroup]="monthlyForm.controls.specificDay"
                                  [use24HourTime]="options.use24HourTime"
                                  [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz">
                </cron-time-picker>
              </span>


            </mat-radio-button>

            <mat-radio-button  name="monthly-radio" value="specificWeekDay">

              <!-- Spesific Week day -->
              <span formGroupName="specificWeekDay">

                Na

                <mat-form-field>
                  <mat-label>Semana</mat-label>
                  <mat-select class="day-order-in-month" formControlName="monthWeek" [ngClass]="options.formSelectClass">
                    <mat-option *ngFor="let monthWeek of selectOptions.monthWeeks" [value]="monthWeek">
                      {{monthWeekDisplay(monthWeek)}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Dia</mat-label>
                  <mat-select class="week-days" formControlName="day" [ngClass]="options.formSelectClass">
                    <mat-option *ngFor="let day of selectOptions.days" [value]="day">
                      {{dayDisplay(day)}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                sempre

                <mat-form-field>
                  <mat-label>Mês</mat-label>
                  <mat-select class="months-small" formControlName="months">
                    <mat-option *ngFor="let month of selectOptions.months" [value]="month">
                      {{month}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                no horário

                <cron-time-picker [formGroup]="monthlyForm.controls.specificWeekDay"
                                  [use24HourTime]="options.use24HourTime"
                                  [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz">

                </cron-time-picker>


              </span>
            </mat-radio-button>

          </mat-radio-group>

        </div>
      </mat-tab>

      <!-- Yearly-->
      <mat-tab class="cron-editor-tab"  label="Anual" *ngIf="!options.hideYearlyTab">

        <div class="cron-editor-tab-content" [formGroup]="yearlyForm">

          <mat-radio-group formControlName="subTab">

            <mat-radio-button name="yearly-radio" value="specificMonthDay">

              No

              <mat-form-field formGroupName="specificMonthDay" *ngIf="options.cronFlavor === 'quartz'">
                <mat-label>Dia</mat-label>
                <mat-select class="month-days" formControlName="day">
                  <mat-option *ngFor="let monthDaysWithLast of selectOptions.monthDaysWithLasts" [value]="monthDaysWithLast">
                    {{monthDayDisplay(monthDaysWithLast)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field formGroupName="specificMonthDay" *ngIf="options.cronFlavor === 'standard'">
                <mat-label>Dia</mat-label>
                <mat-select class="month-days" formControlName="day" >
                  <mat-option *ngFor="let monthDaysWithOutLast of selectOptions.monthDaysWithOutLasts" [value]="monthDaysWithOutLast">
                    {{monthDayDisplay(monthDaysWithOutLast)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              do

              <mat-form-field formGroupName="specificMonthDay">
                <mat-label>Mês</mat-label>
                <mat-select class="months" formControlName="month">
                  <mat-option *ngFor="let month of selectOptions.months" [value]="month">
                    {{monthDisplay(month)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              no horário

              <cron-time-picker [disabled]="disabled"
                                [formGroup]="yearlyForm.controls.specificMonthDay"
                                [use24HourTime]="options.use24HourTime"
                                [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz">
              </cron-time-picker>
            </mat-radio-button>

            <mat-radio-button name="yearly-radio" value="specificMonthWeek" [ngClass]="state.formRadioClass">

              Na

              <mat-form-field formGroupName="specificMonthWeek">
                <mat-label>Semana</mat-label>
                <mat-select class="day-order-in-month" formControlName="monthWeek" >
                  <mat-option *ngFor="let monthWeek of selectOptions.monthWeeks" [value]="monthWeek">
                    {{monthWeekDisplay(monthWeek)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field formGroupName="specificMonthWeek">
                <mat-label>Dia</mat-label>
                <mat-select class="week-days"  formControlName="day" >
                  <mat-option *ngFor="let day of selectOptions.days" [value]="day">
                    {{dayDisplay(day)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              do

              <mat-form-field formGroupName="specificMonthWeek">
                <mat-label>Mês</mat-label>
                <mat-select class="months" formControlName="month">
                  <mat-option *ngFor="let month of selectOptions.months" [value]="month">
                    {{monthDisplay(month)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              no horário

              <cron-time-picker [disabled]="disabled"
                                [formGroup]="yearlyForm.controls.specificMonthWeek"
                                [use24HourTime]="options.use24HourTime"
                                [hideSeconds]="options.hideSeconds || !isCronFlavorQuartz">
              </cron-time-picker>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </mat-tab>

      <!-- Advanced-->
      <mat-tab class="cron-editor-tab" label="Avançado" *ngIf="!options.hideAdvancedTab">
        <div class="cron-editor-tab-content" [formGroup]="advancedForm">

          <mat-form-field>
            <mat-label>Expressão</mat-label>
            <input matInput type="text" class="advanced-cron-editor-input" formControlName="expression">
          </mat-form-field>
        </div>
      </mat-tab>
    </mat-tab-group>
</section>